import React from 'react';
import { AnimatePresence } from 'motion/react';
import { useIntl } from 'react-intl';
import * as motion from 'motion/react-m';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import { useQuizContext } from '../../../../../context/QuizContext';
import { fade } from '../../../../../styles/animation';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';

type Props = {
  index: number;
  eliminatedAnswer: boolean;
  setEliminatedAnswer: React.Dispatch<React.SetStateAction<boolean>>;
};

/**
 * Elimination Tool Icon Buttons.
 */
export const EliminationToolIconButtons = ({
  index,
  eliminatedAnswer,
  setEliminatedAnswer,
}: Props) => {
  const intl = useIntl();
  const { showElimination, setEliminationItems } = useQuizContext();

  const handleElimination = (e: any) => {
    // FIXME: any
    e.stopPropagation();
    setEliminatedAnswer(!eliminatedAnswer);
    setEliminationItems(((prev: number[]) => {
      if (eliminatedAnswer) {
        return prev.filter((item) => item !== index);
      }
      return [index, ...prev];
    }) as any); // FIXME: any
  };

  return (
    <AnimatePresence>
      {showElimination && (
        <motion.div {...fade()}>
          <IconButton
            fontSize={16}
            variant="transparent"
            color="gray60"
            onClick={handleElimination}
            data-testid="elimination-icon"
            aria-label={intl.formatMessage(
              {
                id: 'quiz.elimination-tool.eliminate-answer',
                defaultMessage: 'Eliminate answer choice {number}',
              },
              { number: index + 1 },
            )}
            aria-pressed={eliminatedAnswer}
            icon={
              eliminatedAnswer ? (
                <Icon icon={faPlus} />
              ) : (
                <Icon icon={faTimes} />
              )
            }
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
